<canvas
  #sigCanvas
  class="border border-secondary rounded"
  width="300"
  height="160"
>
  Intenta usar otro navegador web
</canvas>
